var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatus = function SvgStatus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.953,
    cy: 6.047,
    r: 4.051
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9 21.004a9.118 9.118 0 0 0 6.855-6.855M2.996 10.1a9.117 9.117 0 0 1 6.855-6.857M9.85 21.004a9.12 9.12 0 0 1-6.854-6.855"
  }))));
};
export { SvgStatus as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMjNmZjJlOTJlN2Y4NzRhZjNiM2Q5YjRiNjhlMmJkZmYuc3ZnIjs=";